export default "__VITE_ASSET__C0aD4JRT__"